import axios from 'axios';
import { ActionTree, GetterTree, ModuleTree, MutationTree } from "vuex";
import { AsyncState } from "@/common/store/util/AsyncCall";
import { DepotDto } from "@/common/types/DepotDto";
import { DepotKpiDto } from "@/common/types/DepotKpiDto";
import { RootStore } from "@/common/store";
import { TradingServer } from '@/utils/Api';

export interface DepotSearchParameters {
  filter: string
}

export type DashboardStore = {
  depots: AsyncState<DepotDto[], DepotSearchParameters>
  depotKpi: AsyncState<DepotKpiDto, Object>
}

type RootState = RootStore;

let depotState = new AsyncState<DepotDto[], DepotSearchParameters>(
  'depots',
  [],
  { filter: '' });
let depotKpiState = new AsyncState<DepotKpiDto, Object>(
  'depotKpi',
  {
    createdDepots: 0,
    existingDepots: 0,
    pendingDepots: 0,
    connectedDepots: 0,
    declinedDepots: 0,
  },
  {});

const state: DashboardStore = {
  depots: depotState,
  depotKpi: depotKpiState
};

const getters: GetterTree<DashboardStore, RootState> = {
  ...depotState.defaultGetters<DashboardStore>(),
  ...depotKpiState.defaultGetters<DashboardStore>(),
};

const actions: ActionTree<DashboardStore, RootState> = {
  [depotState.getConstants().FETCH]: (store, requestParam: DepotSearchParameters) => {
    const broker = store.rootState.auth.broker;

    if (broker) {
      depotState.asyncApiCall(
        store,
        TradingServer({
          method: 'GET',
          url: '/v2/depots/{broker}/owners',
          urlParams: { broker: broker },
          params: { filter: requestParam.filter }
        }),
        requestParam
      );
    }
  },
  [depotKpiState.getConstants().FETCH]: (store) => {
    const broker = store.rootState.auth.broker;

    if (broker) {
      depotKpiState.asyncApiCall(
        store,
        TradingServer({
          method: 'GET',
          url: '/v2/depots/{broker}/owners/$kpi',
          urlParams: { broker: broker }
        }),
        {}
      );
    }
  },
};

const mutations: MutationTree<DashboardStore> = {
  ...depotState.defaultMutations<DashboardStore>(),
  ...depotKpiState.defaultMutations<DashboardStore>()
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
} as ModuleTree<DashboardStore>;

export const DASHBOARD_STORE = 'dashboard';
export const SEARCH_DEPOTS = DASHBOARD_STORE + '/' + depotState.getConstants().FETCH;
export const DEPOTS_LOADING = depotState.getConstants().LOADING;
export const DEPOTS_LOADED = depotState.getConstants().LOADED;
export const DEPOTS = depotState.getConstants().DATA;
export const FETCH_DEPOTKPI = DASHBOARD_STORE + '/' + depotKpiState.getConstants().FETCH;
export const DEPOTKPI_LOADING = depotKpiState.getConstants().LOADING;
export const DEPOTKPI_LOADED = depotKpiState.getConstants().LOADED;
export const DEPOTKPI = depotKpiState.getConstants().DATA;
